import ScheduleList from './List'

export default function ScheduleListIndex({ schoolEnrollmentId, campusId, memberId, markingPeriodId }) {
  if (!schoolEnrollmentId || !campusId) return null

  return <ScheduleList schoolEnrollmentId={schoolEnrollmentId} campusId={campusId} memberId={memberId} markingPeriodId={markingPeriodId} />
}
